
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"80","viewBox":"0 0 81 80","width":"81","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"d":"M22 21h38.927v38H22z"}})]),_c('circle',{attrs:{"cx":"40.5","cy":"40","fill":"#4677da","r":"40"}}),_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"clip-rule":"evenodd","d":"M42.436 21.51c.026.025.051.05.075.076l3.124 3.307L50.1 23.81a1.854 1.854 0 012.26 1.468l.824 4.506 4.323 1.435a1.854 1.854 0 011.139 2.443l-1.705 4.296 2.824 3.532a1.854 1.854 0 01-.375 2.67l-3.736 2.65.45 4.542a1.854 1.854 0 01-1.663 2.027l-.106.007-4.533.187-2.117 4.092a1.854 1.854 0 01-2.59.743l-3.93-2.328-3.93 2.328a1.854 1.854 0 01-2.591-.743l-2.119-4.092-4.531-.187a1.854 1.854 0 01-1.776-1.928l.008-.106.447-4.543-3.733-2.65a1.854 1.854 0 01-.375-2.669l2.823-3.532-1.705-4.296a1.854 1.854 0 011.14-2.443l4.32-1.435.825-4.506a1.854 1.854 0 012.26-1.468l4.464 1.083 3.125-3.308a1.854 1.854 0 012.62-.075z","fill":"#14d2aa","fill-rule":"evenodd"}}),_c('path',{attrs:{"d":"M37.918 43.777l-3.55-3.55a.998.998 0 00-1.42 0 .998.998 0 000 1.42l4.25 4.25a1.01 1.01 0 001.43 0l10.751-10.742a.998.998 0 000-1.42.998.998 0 00-1.42 0z","fill":"#fff"}})])])
          )
        }
      }
    